// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_text__nDMSC {
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #707070;
  padding: 5px 0;
}

.styles_inputContainer__N-1nm {
  margin-bottom: 30px;
}

.styles_wrapper__fITlB {
  width: 100%;
}

.styles_formButton__jXxqO {
  width: 100% !important;
}

.styles_formButton__jXxqO > button {
  width: 100% !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_submitItem__T-7QA.styles_upload__6Wt1m {
  margin: 0em 5px;
  margin-top: 2em;
  cursor: pointer;
  width: auto;
  min-width: 154px;
  padding: 6px 24px;
  width: auto;
  border-radius: 4px;
  border-radius: 4px;
  height: auto !important;
}

.styles_submitItem__T-7QA.styles_upload__6Wt1m span {
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 25px;
  color: #ffffff;
  text-align: center;
}

.styles_inputStyle__U1onk {
  width: 420px !important;
  height: 44px;
}

@media only screen and (max-width: 1024px) {
  .styles_inputStyle__U1onk {
    width: 353px !important;
    height: 44px;
  }
  .styles_successPadding__okrXR {
    padding-right: 0;
    padding-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/SignUpSuccess/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,cAAA;AACF;;AAGA;EACE,mBAAA;AAAF;;AAEA;EACE,WAAA;AACF;;AACA;EACE,sBAAA;AAEF;;AAAA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAGF;;AACA;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EAEA,kBAAA;EAKA,kBAAA;EACA,uBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;AAHF;;AAMA;EACE,uBAAA;EACA,YAAA;AAHF;;AAWA;EACE;IACE,uBAAA;IACA,YAAA;EARF;EAWA;IACE,gBAAA;IACA,eAAA;EATF;AACF","sourcesContent":[".text {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 20px;\n  text-align: center;\n  color: #707070;\n  padding: 5px 0;\n}\n\n\n.inputContainer{\n  margin-bottom:30px;\n}\n.wrapper{\n  width:100%;\n}\n.formButton{\n  width:100% !important;\n}\n.formButton>button{\n  width:100% !important;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n\n.submitItem.upload {\n  margin: 0em 5px;\n  margin-top: 2em;\n  cursor: pointer;\n  width: auto;\n  min-width: 154px;\n  padding: 6px 24px;\n  width: auto;\n  // height: 36px;\n  border-radius: 4px;\n  // border: 1px solid #ffffff;\n  // color: #ffffff !important;\n// background-color: inherit;\n  // background: #e30813;\n  border-radius: 4px;\n  height:auto !important;\n}\n\n.submitItem.upload span {\n  font-style: normal;\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 25px;\n  color: #ffffff;\n  text-align: center;\n}\n\n.inputStyle {\n  width: 420px !important;\n  height: 44px;\n}\n\n// .successPadding {\n//   padding-right: 1.5rem;\n//   padding-left: 1.5rem;\n// }\n\n@media only screen and (max-width: 1024px) {\n  .inputStyle {\n    width: 353px !important;\n    height: 44px;\n  }\n\n  .successPadding {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `styles_text__nDMSC`,
	"inputContainer": `styles_inputContainer__N-1nm`,
	"wrapper": `styles_wrapper__fITlB`,
	"formButton": `styles_formButton__jXxqO`,
	"submitItem": `styles_submitItem__T-7QA`,
	"upload": `styles_upload__6Wt1m`,
	"inputStyle": `styles_inputStyle__U1onk`,
	"successPadding": `styles_successPadding__okrXR`
};
export default ___CSS_LOADER_EXPORT___;
